export default "__VITE_ASSET__DgH2MOqu__"